import {MusicType} from "./MusicModel";
import {AbstractMusicActivity} from "./AbstractMusicActivity";
import {didgeridoo} from "../../Layout/MusicScreenLayout";
import {AudioChannel} from "../../Core/AudioChannel";
import {MusicNotesEmit} from "./MusicNotesEmit";
import {InstrumentButton} from "./InstrumentButton";
import {Ease} from "../../Core/Animatable";
import {Keyboard} from "../Keyboard";
import {HomeScreen} from "../../States/HomeScreen";

const reactionVO = [
    "LetsGoLuna_211",
    "LetsGoLuna_212"
];

export class DidgeridooActivity extends AbstractMusicActivity<InstrumentButton> {

    readonly button: InstrumentButton;

    constructor(screen: HomeScreen) {
        super(screen);

        didgeridoo.call(this);
        this.sprite.saveTransform();

        this.button = this.sprite as any;
        this.button.enabled = false;

        const notes = this.container.addChild(new MusicNotesEmit(this.button.width * 0.5, this.button.width * 0.5, "#eb553d"));
        notes.x = this.button.x;
        notes.y = this.button.y;

        let bgmVolume = 0;
        let isDown = false;
        const s = this.button.animation.scale.x;
        const onUp = () => {
            if (isDown) {
                isDown = false;
                AudioChannel.SFX.stop(`${MusicType.Didgeridoo}`);
                AudioChannel.SFX.play(`${MusicType.Didgeridoo}-end`);
                AudioChannel.BGM.volume = bgmVolume;
                notes.emitter.emit = false;
                this.button.enabled = true;
                this.playReactionVO();
            }
        };

        this.button.onDown.add(() => {
            if (isDown) return;
            isDown = true;
            AudioChannel.SFX.play(`${MusicType.Didgeridoo}`, "loop");
            notes.emitter.emit = true;
            bgmVolume = AudioChannel.BGM.volume;
            AudioChannel.BGM.volume = 0;

            this.button.killTweens();
            const tween = () => {
                this.button.animation.scaleTo(s * 0.92, 0.4, Ease.sineInOut, () => {
                    this.button.animation.scaleTo(s, 0.4, Ease.sineInOut, () => {
                        if (isDown) tween();
                    });
                });
            };
            tween();
        });
        this.button.onUp.add(onUp);
        this.button.onOut.add(onUp);
    }

    protected getSprite(): InstrumentButton {
        return new InstrumentButton();
    }

    protected getMusicType(): MusicType {
        return MusicType.Didgeridoo;
    }

    protected activate() {
        super.activate();
        this.button.enabled = true;
        Keyboard.focus(this.button);
    }

    protected deactivate() {
        this.button.enabled = false;
        super.deactivate();
    }

    protected getReactionVO(): string[] | undefined {
        return reactionVO;
    }

    protected getFactVO(): string | undefined {
        return "LetsGoLuna_213";
    }
}